const NotFoundPage = () => {
    return (
        <div>
            Page Not Found ! 
        </div>
    );
  };
  
  export default NotFoundPage;
  